import React from "react";

interface Prop {
  title: string;
  mobileMarginBottom?: string;
}

const MainTitle: React.FC<Prop> = ({ title, mobileMarginBottom }) => {
  return (
    <>
      <div
        className={`text-center font-Poppins text-primary font-bold text-[24px] md:text-[40px] mb-4 ${mobileMarginBottom}`}
      >
        <h6>{title}</h6>
      </div>
    </>
  );
};

export default MainTitle;
